import { ArrowRight } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { STEPS } from "@/data/content";

const Connector = () => (
  <div className="pointer-events-none absolute -right-8 top-1/2 hidden w-8 -translate-y-1/2 items-center md:flex" aria-hidden="true">
    <span className="h-px flex-1 bg-[#bdbdb4]" />
    <ArrowRight className="-ml-1 h-3.5 w-3.5 text-[#ff6600]" strokeWidth={2} />
  </div>
);

export const HowItWorks = () => (
  <section id="how-it-works" className="cd-section" data-testid="how-it-works-section">
    <div className="mx-auto max-w-[1360px] px-5 sm:px-8">
      <SectionHeading id="how-it-works" title="How it works" />
      <ol className="cd-reveal mt-12 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-8">
        {STEPS.map((s, i) => (
          <li key={s.title} className="cd-step relative flex flex-col border border-[#bdbdb4] bg-[#fbfbf6] p-7 sm:p-8" data-testid={`how-step-${i + 1}`}>
            <span className="font-display text-6xl font-semibold leading-none tracking-[-0.04em] text-[#ff6600]">{i + 1}</span>
            <h3 className="mt-10 font-display text-2xl font-semibold tracking-[-0.02em] text-[#292929]" data-testid={`how-step-title-${i + 1}`}>{s.title}</h3>
            <p className="mt-3 text-[15px] leading-relaxed text-[#55554f]" data-testid={`how-step-line-${i + 1}`}>{s.body}</p>
            {i < STEPS.length - 1 && <Connector />}
          </li>
        ))}
      </ol>
    </div>
  </section>
);
